<template>
	<Dropdown :position="isSmallScreen ? 'bottom-end' : 'bottom-start'">
		<template #trigger>
			<button type="button" :title="$t('Text color')" class="w-6 h-6 rounded flex items-center justify-center relative shrink-0" tabindex="-1">
				<span class="font-bold relative select-none">
					A
					<span
						class="absolute bottom-0 left-1/2 -translate-x-1/2 h-[0.1875rem] rounded"
						:style="{ width: '1rem', backgroundColor: activeColor || 'transparent' }"
					/>
				</span>
			</button>
		</template>
		<template #content>
			<div class="bg-white rounded-lg shadow-lg p-4" style="width: min(12rem, 92vw); max-width: 92vw">
				<div class="grid grid-cols-4 gap-1">
					<button
						v-for="color in colors"
						:key="color"
						type="button"
						class="w-8 h-4 rounded border hover:scale-110 transition-all"
						:class="{ 'ring-2 ring-accent': color === activeColor }"
						:style="{ backgroundColor: color }"
						@mousedown.prevent="onApplyColor(color)"
						@click="onApplyColor(color)"
					/>
				</div>
			</div>
		</template>
	</Dropdown>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import Dropdown from "@/components/ui/Dropdown.vue";

export default defineComponent({
	name: "TextColorButton",
	components: { Dropdown },
	props: {
		editor: { type: Object as PropType<any>, required: false },
		isSmallScreen: { type: Boolean, default: false },
		activeColor: { type: String, default: "#000000" },
		colors: { type: Array as PropType<string[]>, default: () => [] },
	},
	emits: ["update:activeColor"],
	methods: {
		onApplyColor(color: string) {
			const e = this.editor as any;
			if (!e) return;
			e.chain().focus().setColor(color).run();
			if (e.isActive("link")) {
				const current = (e.getAttributes("link") as Record<string, any>) || {};
				e.chain()
					.focus()
					.extendMarkRange("link")
					.setLink({ ...current, style: `color: ${color}` })
					.run();
			}
			// Emit event to update activeColor in parent immediately
			this.$emit("update:activeColor", color);
		},
	},
});
</script>
